import React, { useState, useEffect } from 'react';
import { Music, Mic2, TrendingUp } from 'lucide-react';
import { adminService } from '../services/adminApi';

const DashboardStats = () => {
  const [stats, setStats] = useState({
    total_songs: '...',
    total_hymns_sung: '...',
    total_services: '...'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await adminService.getDashboardStats();
        setStats({
          total_songs: data.total_songs.toLocaleString(),
          total_hymns_sung: data.total_hymns_sung.toLocaleString(),
          total_services: data.total_services.toLocaleString()
        });
      } catch (err) {
        console.error("Failed to fetch dashboard stats", err);
        setStats({
          total_songs: 'Err',
          total_hymns_sung: 'Err',
          total_services: 'Err'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const getAverageSongs = () => {
    if (loading) return '...';
    if (stats.total_hymns_sung === 'Err' || stats.total_services === 'Err') return 'Err';
    const hymns = parseFloat(String(stats.total_hymns_sung).replace(/,/g, ''));
    const services = parseFloat(String(stats.total_services).replace(/,/g, ''));
    if (isNaN(hymns) || isNaN(services) || services === 0) return '0.0';
    return (hymns / services).toFixed(1);
  };

  const statItems = [
    { 
      label: 'Total Songs in Database', 
      value: stats.total_songs, 
      icon: Music, 
      color: 'text-blue-600', 
      bg: 'bg-blue-50',
      border: 'border-blue-100'
    },
    { 
      label: 'Hymns Sung (last 2 months)', 
      value: stats.total_hymns_sung, 
      icon: Mic2, 
      color: 'text-purple-600', 
      bg: 'bg-purple-50',
      border: 'border-purple-100'
    },
    { 
      label: 'Avg Songs Per Service', 
      value: getAverageSongs(), 
      icon: TrendingUp, 
      color: 'text-emerald-600', 
      bg: 'bg-emerald-50',
      border: 'border-emerald-100'
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8 w-full">
      {statItems.map((stat, idx) => {
        const Icon = stat.icon;
        return (
          <div 
            key={idx} 
            className={`group bg-white p-6 rounded-3xl border ${stat.border} shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex items-center gap-6 relative overflow-hidden`}
          >
            <div className={`w-16 h-16 flex-shrink-0 rounded-2xl ${stat.bg} ${stat.color} flex items-center justify-center shadow-inner group-hover:scale-110 transition-transform duration-300`}>
              <Icon size={32} strokeWidth={2.5} />
            </div>
            
            <div className="relative z-10">
              <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">
                {stat.label}
              </p>
              <h3 className={`text-3xl font-extrabold text-gray-900 tracking-tight ${loading ? 'animate-pulse bg-gray-200 rounded text-transparent' : ''}`}>
                {stat.value}
              </h3>
            </div>

            {/* Decorative background blob */}
            <div className={`absolute -right-6 -bottom-6 w-24 h-24 rounded-full ${stat.bg} opacity-50 group-hover:scale-150 transition-transform duration-500`} />
          </div>
        );
      })}
    </div>
  );
};

export default DashboardStats;